// import Vue from 'vue'
const $toastAuto = function (txt, type = 'txt', time = 1000) {
  const toast = this.$createToast({
    txt: txt,
    time: time,
    type: type
  })
  toast.show()
}
const $toastDefined = function (txt, flag, mask = false, type = 'txt') {
  const toast = this.$createToast({
    txt: txt,
    time: 0,
    type: type,
    mask: mask
  })
  if (flag === 'show') {
    toast.show()
  } else if (flag === 'hide') {
    toast.hide()
  }
}

let selfCube = {}
selfCube.install = function (Vue, option) {
  Vue.prototype.$toastAuto = $toastAuto
  Vue.prototype.$toastDefined = $toastDefined
}
export default selfCube



// WEBPACK FOOTER //
// ./src/libs/selfCube.js